import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative bg-background-900 rounded-3xl overflow-hidden">
          <div className="absolute top-0 left-0 w-64 h-64 opacity-5">
            <span className="text-background-50 text-[200px] font-serif leading-none">&ldquo;</span>
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-16 p-8 md:p-14">
            <div className="lg:w-2/5 flex-shrink-0">
              <div className="relative -mt-20 lg:-mt-32 lg:-mb-20">
                <div className="w-48 h-56 md:w-64 md:h-80 rounded-xl overflow-hidden bg-background-600 border-4 border-background-50 mx-auto lg:mx-0 lg:-ml-8">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%20with%20confident%20expression%20modern%20casual%20style%20clean%20neutral%20grey%20background%20editorial%20fashion%20photography%20soft%20natural%20lighting%20headshot&width=300&height=380&seq=testimonial-portrait&orientation=portrait"
                    alt="51爆料忠实用户"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center">
              <span className="text-6xl md:text-8xl font-serif text-background-100 leading-none mb-2">&ldquo;</span>
              <blockquote className="text-lg md:text-xl text-background-50 leading-relaxed mb-6 font-medium">
                {testimonials[0].content}
              </blockquote>
              <div className="mb-6">
                <p className="text-background-50 font-semibold text-sm">{testimonials[0].author}</p>
                <p className="text-foreground-400 text-xs mt-0.5">{testimonials[0].role}</p>
              </div>
              <button
                onClick={() => {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-1 px-5 py-2.5 bg-primary-400/20 text-primary-300 rounded-full text-sm font-medium hover:bg-primary-400/30 transition-all duration-200 cursor-pointer whitespace-nowrap self-start"
              >
                查看更多口碑
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}